const actions = {
    async login({}, form) {
        return await this.$api.auth.login(form);
    },
    async check({}, form) {
        return await this.$api.auth.check(form);
    },
    async sendCode({}, form) {
        return await this.$api.auth.send(form);
    },
    async verifyCode({}, form) {
        return await this.$api.auth.verifyCode(form);
    },
    async createRequest({}, {
        form,
        token
    }) {
        return await this.$api.orders.createRequestPublic(form, token);
    },
    async register({
        commit
    }, form) {
        return await this.$api.auth.register(form);
    },
    async uploadImage({}, {
        form,
        id,
        token
    }) {
        if (!form) {
            return;
        }

        const fd = new FormData();

        fd.append("request_id", id);
        fd.append("media", form);

        return await this.$api.orders.uploadImagePublic({
            form: fd,
            id,
        }, token);
    },
    async addFiles({}, {
        form,
        token
    }) {
        return await this.$api.orders.addFilesPublic(form, token);
    },
};

export default {
    namespaced: true,
    actions
}